import React, { useEffect, useState, useCallback } from "react";
import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  const loadCount = useCallback(() => api.get("/notifications/unread-count").then((r) => setCount(r.data.count)).catch(() => {}), []);
  const loadItems = useCallback(() => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {}), []);

  useEffect(() => {
    loadCount();
    const t = setInterval(loadCount, 45000);
    return () => clearInterval(t);
  }, [loadCount]);

  const onOpen = (o) => { if (o) loadItems(); };
  const markRead = async (n) => {
    await api.post(`/notifications/${n.id}/read`);
    loadCount(); loadItems();
    if (n.link) navigate(n.link);
    else if (n.project_id) navigate(`/projects/${n.project_id}`);
  };
  const readAll = async (e) => { e.stopPropagation(); await api.post("/notifications/read-all"); loadCount(); loadItems(); };

  return (
    <DropdownMenu onOpenChange={onOpen}>
      <DropdownMenuTrigger asChild>
        <button data-testid="notif-bell" className="relative p-2 rounded-lg hover:bg-slate-100 outline-none">
          <Bell className="h-5 w-5 text-slate-600" />
          {count > 0 && (
            <span data-testid="notif-unread-badge" className="absolute -top-0.5 -right-0.5 h-4 min-w-4 px-1 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center">
              {count > 9 ? "9+" : count}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-0" data-testid="notif-panel">
        <div className="flex items-center justify-between px-3 py-2 border-b border-slate-100">
          <span className="font-semibold text-sm text-slate-900">Benachrichtigungen</span>
          {items.some((i) => !i.read) && <button onClick={readAll} className="text-xs text-primary font-medium" data-testid="notif-read-all">Alle als gelesen</button>}
        </div>
        <div className="max-h-96 overflow-auto scroll-thin">
          {items.length === 0 && <div className="p-6 text-center text-sm text-slate-400">Keine Benachrichtigungen</div>}
          {items.map((n) => (
            <button key={n.id} onClick={() => markRead(n)} data-testid={`notif-item-${n.id}`}
              className={`w-full text-left px-3 py-2.5 border-b border-slate-100 hover:bg-slate-50 flex gap-2 ${n.read ? "opacity-60" : ""}`}>
              <span className={`mt-1.5 h-2 w-2 rounded-full shrink-0 ${n.read ? "bg-transparent" : "bg-red-500"}`} />
              <div className="min-w-0">
                <div className="text-sm font-medium text-slate-900 truncate">{n.title}</div>
                {n.message && <div className="text-xs text-slate-500 truncate">{n.message}</div>}
                <div className="text-[10px] text-slate-400 mt-0.5">{(n.created_at || "").slice(0, 16).replace("T", " ")}</div>
              </div>
            </button>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
